import { render } from "./HomeStatsCard.vue?vue&type=template&id=0af59a2d&scoped=true"
import script from "./HomeStatsCard.vue?vue&type=script&lang=js"
export * from "./HomeStatsCard.vue?vue&type=script&lang=js"

import "./HomeStatsCard.vue?vue&type=style&index=0&id=0af59a2d&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_06ebbe948ebbc1bd3ebd6c3aad4ab6ee/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af59a2d"]])

export default __exports__